import { Link } from "react-router-dom";
import React, { useState } from "react";
import "../../../asset/css/itemcard.css";

import AlertComponent from "../../../components/AlertComponent";
import ErrorAlert from "../../../components/ErrorAlert";

import DeleteForm from "./DeleteForm";
import EditForm from "./EditForm";

function ItemCard({ item, onImageUpdated }) {
  const [alert, setAlert] = useState("");
  const [editForm, setEditForm] = useState(false);
  const [deleteForm, setDeleteForm] = useState(false);

  return (
    <div className="p-4 w-full md:w-1/2 xl:w-1/4 bg-white border border-1 rounded ">
      <div className="h-full">
        <div className="rounded-lg bg-gray-100 p-6 h-full flex flex-col items-end justify-between">
          <Link to={`${process.env.PUBLIC_URL}/item/${item.id}`}>
            {item.image ? (
              <img
                // className="mb-6 h-64 w-full rounded object-cover object-center"
                src={`${process.env.REACT_APP_IMAGE_URL}/${item.image}.png?v=${Date.now()}`}
                alt={`Image for product #${item.id}`}
              />
            ) : (
              <img
                className="mb-6 h-64 w-full rounded object-cover object-center"
                src="#"
                alt={`Image for product #${item.id} is not found`}
              />
            )}
            <h2 className="title-font mb-4 text-right text-lg font-medium text-gray-900">
              {item.name}
            </h2>
          </Link>

          <p className="text-right text-base leading-relaxed mb-2">{item.description}</p>
          {alert === "error" ? (
            <ErrorAlert
              title={"فشل تحديث المعلومات"}
              content={"يرجى التأكد من إدخال معلومات صحيحة والمحاولة مرة أخرى لاحقا"}
            />
          ) : alert === "update" ? (
            <AlertComponent
              title={"تم تحديث المعلومات بنجاح"}
              content={`تمت إضافة المعلومات جديد بإسم  ${item.name}  بنجاح`}
            />
          ) : alert === "delete" ? (
            <AlertComponent
              title={"تم حذف المنتج بنجاح"}
              content={`تمت حذف المنتج بإسم  ${item.name}  بنجاح`}
            />
          ) : (
            ""
          )}

          <button
            className=" my-2 w-32 px-3 py-2 text-sm font-medium text-center text-white bg-red-700 rounded-lg hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-blue-300"
            onClick={() => setDeleteForm((prev) => !prev)}
          >
              حذف
          </button>
          {deleteForm && (
            <DeleteForm item={item} setDeleteForm={setDeleteForm} setAlert={setAlert} />
          )}
          <button
            className=" my-2 w-32 px-3 py-2 text-sm font-medium text-center text-white bg-blue-700 rounded-lg hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300"
            onClick={() => setEditForm((prev) => !prev)}
          >
            تعديل
          </button>
          {editForm && (
            <EditForm
              item={item}
              setEditForm={setEditForm}
              setAlert={setAlert}
              onImageUpdated={onImageUpdated}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default ItemCard;
